import React, { useRef } from 'react';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import { useClickOutside } from 'utils/hooks';
import { layout } from './ModalLayout.module.scss';

export default function ModalLayout({
  filteredProjects,
  flags,
  filtersOptions,
  defaultFilters,
  filters,
  setFilters,
  handleClose,
  showTags,
  setShowTags,
}) {
  const modalRef = useRef(null);

  const handleClear = () => {
    setFilters(defaultFilters);
    setShowTags(false);
  };

  useClickOutside([modalRef], handleClose);

  return (
    <div ref={modalRef} className={layout}>
      <ModalHeader handleClose={handleClose} />
      <ModalContent
        filteredProjects={filteredProjects}
        showTags={showTags}
        setShowTags={setShowTags}
        filtersOptions={filtersOptions}
        flags={flags}
        filters={filters}
        setFilters={setFilters}
      />
      <ModalFooter
        handleClear={handleClear}
        handleShowResults={handleClose}
        filtersAmount={Object.values(filters)?.flat().length}
        resultsAmount={filteredProjects.length}
      />
    </div>
  );
}
